import { Helmet } from "react-helmet";
import { FC } from "react";
import AffectedReservationGridDetailedCard from "./MadeReservationGridDetailedCard ";

import CommonLayout from "../../AccountPage/CommonLayout";

export interface AccountPageProps {
  className?: string;
}

const ClientMadeReservationPage: FC<AccountPageProps> = ({ className = "" }) => {
  return (
    <CommonLayout>
      <div
        className={`overflow-hidden relative nc-ListingFlightsPage ${className}`}
        data-nc-id="ListingFlightsPage"
      >
        <Helmet>
          <title>
            EventToBee | Location d'espaces : salles, lofts, jardins & boutiques – Paris & Île-de-France
          </title>
        </Helmet>

        <div className="">
          <AffectedReservationGridDetailedCard className="pb-24 lg:b-28" />
        </div>
      </div>
    </CommonLayout>
  );
};

export default ClientMadeReservationPage;
